import React from 'react';
import { connect } from 'react-redux';
import config from '../../configuration.json';
class Footer extends React.Component {

    state = {
        footerHeight: 0
    };

    footerRef = React.createRef();

    componentDidMount() {
        const footerHeight = this.footerRef.current.clientHeight;
        if (footerHeight !== this.state.footerHeight){
            this.setState({ footerHeight: footerHeight});
        }
    }

    render() {
        return (
            <>
            {/* <div style={{height: `${this.state.footerHeight}px`}}></div> */}
            <footer id={this.props.footerName} ref={this.footerRef}>
                

  <div className='play-menu-footer_mm' >
    <a href={config.PlayAndPizza.Urls.LegalBasesUrl}>Bases legales</a><br/>
    <a href={config.PlayAndPizza.Urls.CookiesPolicyPdfUrl} >Política de cookies</a><br/>
    <p onClick={()=> window.cc.showSettings(0)}  >Configurador de cookies</p>
  </div>

  <hr className='play-menu-footer_hr'/>

<div className='play-menu-footer_div'>
  <p  className='play-menu-footer_p' >
    Si tienes problemas, ponte en contacto con nosotros en 
    <a href='mailto:CRM.es@fooddeliverybrands.com' className='play-menu-footer_a'>
        CRM.es@fooddeliverybrands.com
    </a>
  </p>
</div>



            </footer>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {

    };
};

export default connect(mapStateToProps, {})(Footer);


